import { inject, injectable } from 'inversify';
import { EventDependencyTypes, type EventManager } from '@kiplin/web-common/event';
import { BaseError } from '@kiplin/web-common/error';
import { BaseException } from '@kiplin/web-common/exception';
import { ClientGamesRefreshCompletedEvent } from '@client/entity/client-game/domain/event/client-games-refresh-completed.event';
import type { ClientGamesRefreshRequestedEvent } from '@client/entity/client-game/domain/event/client-games-refresh-requested.event';
import { ClientGamesRefreshFailedError } from '@client/entity/client-game/domain/error/client-games-refresh-failed.error';

@injectable()
export class ClientGamesRefreshCompletionDispatcherService {
  public constructor(
    @inject(EventDependencyTypes.EventManager)
    private readonly eventManager: EventManager,
  ) {}

  public dispatchCompleted(event: ClientGamesRefreshRequestedEvent): void {
    this.dispatch(event);
  }

  public dispatchFailed(event: ClientGamesRefreshRequestedEvent, error: unknown): void {
    this.dispatch(event, this.toRefreshError(error));
  }

  private dispatch(event: ClientGamesRefreshRequestedEvent, error?: BaseError | BaseException): void {
    this.eventManager.dispatch(
      new ClientGamesRefreshCompletedEvent({
        detail: {
          clientId: event.detail.clientId,
          error,
          gameId: event.detail.gameId,
          gameKind: event.detail.gameKind,
          requestId: event.detail.requestId,
        },
      }),
    );
  }

  private toRefreshError(error: unknown): BaseError | BaseException {
    if (error instanceof BaseError || error instanceof BaseException) {
      return error;
    }

    return new ClientGamesRefreshFailedError();
  }
}
